import React from "react"
import BasicContentBlock from "./basic-content-block"
import AltImageText from "./alt-image-text"
import Highlights from "./highlights"
import MainContent from "../components/main-content"
import PageByNumbers from "./page-by-numbers"
import Video from "./video"
import Quote from "./quote"
import Milestones from "./milestones"
import ExpandableGroups from "./expandable-groups"
import Gallery from "./gallery"
import IconList from "./icon-list"
import CountryGroup from "./country-group"
import PieChart from "./pie-chart"
import OutcomesAllCountries from "./outcomes-all-countries"
import NewsArchive from "./news-archive"
import EventsArchive from "./events-archive"
import PostHighlights from "./post-highlights"
import KnowledgeHubArchive from "./knowledge-hub-archive"
import EventSearch from "./event-search"
import NewsSearch from "./news-search"
import InternalResources from "./internal-resources"
import StickyMenu, { hasStickyMenu } from "./sticky-menu"
import Infographic from "./infographic"

const CustomSections = ({ sections, content, annualReport, location }) => {
  if (!sections || !sections.length) {
    return <div></div>
  }
  let altSectionCount = 0
  sections.forEach(section => {
    if (
      section.fieldGroupName.includes(
        "Customsections_Customsections_AltImgText"
      )
    ) {
      section.index = altSectionCount
      altSectionCount++
    }
  })
  const hasMenu = hasStickyMenu(sections)

  return (
    <>
      {sections?.map((section, i) => {
        const fieldGroupName = section?.fieldGroupName
        if (fieldGroupName && typeof (fieldGroupName) === "string") {
          return <>
            {fieldGroupName.includes(
              "Customsections_Customsections_AltImgText"
            ) ? (
              <AltImageText props={section} key={i} annualReport={annualReport} />
            ) : fieldGroupName.includes(
              "Customsections_Customsections_BasicContentBlock"
            ) ? (
              <BasicContentBlock props={section} key={i} annualReport={annualReport} index={i} />
            ) : fieldGroupName.includes(
              "Customsections_Customsections_Highlights"
            ) ? (
              <Highlights props={section} key={i} annualReport={annualReport} index={i} hasMenu={hasMenu} />
            ) : fieldGroupName.includes(
              "Customsections_Customsections_MainContent"
            ) ? (
              <MainContent content={content} props={section} key={i} />
            ) : fieldGroupName.includes(
              "Customsections_Customsections_PageByNumbers"
            ) ? (
              <PageByNumbers props={section} key={i} annualReport={annualReport} />
            ) : fieldGroupName.includes("Customsections_Customsections_Video") ? (
              <Video props={section} key={i} />
            ) : fieldGroupName.includes("Customsections_Customsections_Quote") ? (
              <Quote props={section} key={i} annualReport={annualReport} />
            ) : fieldGroupName.includes(
              "Customsections_Customsections_Milestones"
            ) ? (
              <Milestones props={section} key={i} annualReport={annualReport} />
            ) : fieldGroupName.includes(
              "Customsections_Customsections_Expandablegroups"
            ) ? (
              <ExpandableGroups props={section} key={i} annualReport={annualReport} />
            ) : fieldGroupName.includes(
              "Customsections_Customsections_Gallery"
            ) ? (
              <Gallery props={section} key={i} />
            ) : fieldGroupName.includes(
              "Customsections_Customsections_CountryGroup"
            ) ? (
              <CountryGroup props={section} key={i} />
            ) : fieldGroupName.includes(
              "Customsections_Customsections_IconList"
            ) ? (
              <IconList props={section} key={i} />
            ) : fieldGroupName.includes(
              "Customsections_Customsections_PieChart"
            ) ? (
              <PieChart props={section} key={i} annualReport={annualReport} />
            ) : fieldGroupName.includes(
              "Customsections_Customsections_OutcomesAllCountries"
            ) ? (
              <OutcomesAllCountries props={section} key={i} />
            ) : fieldGroupName.includes(
              "Customsections_Customsections_NewsArchive"
            ) ? (
              <>
                {section?.type === "search" ? <NewsSearch props={section} key={i} location={location} /> : <NewsArchive props={section} key={i} />}
              </>
            ) : fieldGroupName.includes(
              "Customsections_Customsections_EventsArchive"
            ) ? (
              <>
                {section?.type === "search" ? <EventSearch props={section} key={i} location={location} /> : <EventsArchive props={section} key={i} />}
              </>
            ) : fieldGroupName.includes(
              "Customsections_Customsections_PostHighlights"
            ) ? (
              <PostHighlights props={section} key={i} />
            ) : fieldGroupName.includes(
              "Customsections_Customsections_KnowledgeHubArchive"
            ) ? (
              <KnowledgeHubArchive props={section} key={i} location={location} />
            ) : fieldGroupName.includes(
              "Customsections_Customsections_InternalResources"
            ) ? (
              <InternalResources props={section} key={i} location={location} />
            ) : fieldGroupName.includes(
              "Customsections_Customsections_Infographic"
            ) ? (
              <Infographic props={section} key={i} />
            ) : null}
            {annualReport === "2024" && i === 0 && hasMenu ? <StickyMenu sections={sections} annualReport={annualReport} /> : null}
          </>
        } else {
          return null
        }
      })}
    </>
  )
}

export default CustomSections
